export default "__VITE_ASSET__DbX382rv__"